export interface AppNotification {
  id: string | number;
  type: AppNotificationType;
  title: string;
  message: string;
  link?: string;
  read: boolean;
  createdAt: Date;
  readAt?: Date;
  metadata?: Record<string, any>;
}

export interface PagedNotificationResponse {
  content: AppNotification[];
  currentPage: number;
  totalPages: number;
  totalElements: number;
  unreadTotal: number;
}

export enum AppNotificationType {
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  TASK = 'TASK',
  REPORT = 'REPORT',
}

export interface NotificationWebSocketMessage {
  type: 'NOTIFICATION';
  payload: AppNotification;
}
